"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.placementFromClick = placementFromClick;
exports.placementToOverlay = placementToOverlay;
exports.GraphicPlacePicker = GraphicPlacePicker;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
/** Ułamki obrazu liczone od góry zamieniamy na prostokąt PDF liczony od dołu. */
function placementFromClick(page, size, stampRel, fx, fy) {
    const width = Math.min(stampRel.width, 1) * size.width;
    const height = Math.min(stampRel.height, 1) * size.height;
    return {
        page,
        rect: {
            x: Math.max(0, Math.min(fx * size.width - width / 2, size.width - width)),
            y: Math.max(0, Math.min((1 - fy) * size.height - height / 2, size.height - height)),
            width,
            height,
        },
    };
}
function placementToOverlay({ rect }, size) {
    return {
        left: `${(rect.x / size.width) * 100}%`,
        top: `${((size.height - rect.y - rect.height) / size.height) * 100}%`,
        width: `${(rect.width / size.width) * 100}%`,
        height: `${(rect.height / size.height) * 100}%`,
    };
}
/** Treść i stopka tej samej fazy okna podpisu; wybór zatwierdzamy dopiero przyciskiem. */
function GraphicPlacePicker({ fileName, search, initial, initialPage, loadPage, onConfirm, onCancel, children }) {
    const [page, setPage] = (0, react_1.useState)(initial?.page ?? initialPage ?? 1);
    const [placement, setPlacement] = (0, react_1.useState)(initial);
    const [image, setImage] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const [attempt, setAttempt] = (0, react_1.useState)(0);
    const size = search.pages[page - 1];
    const overlay = (0, react_1.useRef)(null);
    // Po wczytaniu strony z już ustawionym miejscem pokazujemy to miejsce, a nie górę strony.
    (0, react_1.useEffect)(() => {
        if (image?.page === page && placement?.page === page)
            overlay.current?.scrollIntoView?.({ block: "center" });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image]);
    /** Wybór bez myszy: Enter albo spacja stawia grafikę na środku strony, strzałki ją przesuwają (Shift: większy krok). */
    function onKeyDown(event) {
        if (!size.placeable)
            return;
        const current = placement?.page === page ? placement.rect : undefined;
        const step = event.shiftKey ? 0.05 : 0.01;
        const move = {
            ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step],
        };
        let fx = current ? (current.x + current.width / 2) / size.width : 0.5;
        let fy = current ? 1 - (current.y + current.height / 2) / size.height : 0.5;
        if (event.key === "Enter" || event.key === " ") {
            if (current)
                return;
        }
        else if (move[event.key] && current) {
            fx += move[event.key][0];
            fy += move[event.key][1];
        }
        else
            return;
        event.preventDefault();
        setPlacement(placementFromClick(page, size, search.stampRel, fx, fy));
    }
    (0, react_1.useEffect)(() => {
        let active = true;
        let objectUrl;
        setImage(null);
        setError(null);
        async function load() {
            try {
                const blob = await loadPage(page);
                if (!active)
                    return;
                objectUrl = URL.createObjectURL(blob);
                setImage({ page, url: objectUrl });
            }
            catch (reason) {
                if (active)
                    setError(reason instanceof Error ? reason.message : "Sprawdź połączenie z PS.");
            }
        }
        load();
        return () => {
            active = false;
            if (objectUrl)
                URL.revokeObjectURL(objectUrl);
        };
    }, [page, loadPage, attempt]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            children,
            react_1.default.createElement("h6", { style: { overflowWrap: "anywhere" } },
                "Miejsce grafiki \u2014 ",
                fileName),
            react_1.default.createElement("p", { className: "small text-muted" }, "Kliknij w miejscu, w kt\u00F3rym ma stan\u0105\u0107 grafika podpisu. Gotowy PDF zobaczysz jeszcze przed wpisaniem PIN-u. Bez myszy: przejd\u017A klawiszem Tab na obraz strony, Enter postawi grafik\u0119 na \u015Brodku, strza\u0142ki j\u0105 przesun\u0105."),
            search.pages.length > 1 && (react_1.default.createElement("div", { className: "d-flex flex-wrap align-items-center justify-content-between mb-2", style: { gap: "8px" } },
                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", disabled: page === 1, onClick: () => setPage(page - 1) }, "\u2039 Poprzednia"),
                react_1.default.createElement("span", { className: "small text-muted" },
                    "Strona ",
                    page,
                    " z ",
                    search.pages.length),
                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", disabled: page === search.pages.length, onClick: () => setPage(page + 1) }, "Nast\u0119pna \u203A"))),
            placement && placement.page !== page && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "small py-2" },
                "Miejsce grafiki jest teraz wskazane na stronie ",
                placement.page,
                ", nie na tej.",
                " ",
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", size: "sm", className: "p-0 align-baseline", onClick: () => setPage(placement.page) },
                    "Poka\u017C stron\u0119 ",
                    placement.page),
                " ",
                "albo kliknij tutaj, \u017Ceby przenie\u015B\u0107 grafik\u0119 na t\u0119 stron\u0119.")),
            !size.placeable && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "small py-2" }, "Na tej stronie nie da si\u0119 ustawi\u0107 grafiki (ma nietypowy uk\u0142ad, np. jest obr\u00F3cona). Wybierz inn\u0105 stron\u0119.")),
            error ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "small py-2" },
                "Nie uda\u0142o si\u0119 wczyta\u0107 strony ",
                page,
                ": ",
                error,
                react_1.default.createElement("div", { className: "mt-2" },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", onClick: () => setAttempt((prev) => prev + 1) }, "Spr\u00F3buj ponownie")))) : image?.page === page ? (react_1.default.createElement("div", { className: "position-relative", style: { width: "100%" }, tabIndex: 0, role: "group", "aria-label": `Strona ${page}: Enter stawia grafikę na środku, strzałki ją przesuwają`, onKeyDown: onKeyDown },
                react_1.default.createElement("img", { src: image.url, alt: `Strona ${page} dokumentu ${fileName}`, className: "d-block border", style: { width: "100%", maxWidth: "100%", cursor: size.placeable ? "crosshair" : "default" }, onClick: (event) => {
                        if (!size.placeable)
                            return;
                        const bounds = event.currentTarget.getBoundingClientRect();
                        if (bounds.width <= 0 || bounds.height <= 0)
                            return;
                        setPlacement(placementFromClick(page, size, search.stampRel, (event.clientX - bounds.left) / bounds.width, (event.clientY - bounds.top) / bounds.height));
                    } }),
                placement?.page === page && (react_1.default.createElement("div", { ref: overlay, "aria-label": "Tu stanie grafika podpisu", className: "position-absolute bg-success bg-opacity-25 border border-success small text-success d-flex align-items-center justify-content-center", style: { ...placementToOverlay(placement, size), pointerEvents: "none", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "clamp(.6rem, 1.6vw, .8rem)" } }, "tu stanie grafika")))) : (react_1.default.createElement("div", { className: "small text-muted", role: "status" },
                react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", "aria-hidden": "true", className: "me-2" }),
                "Wczytuj\u0119 stron\u0119 ",
                page,
                "\u2026"))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: onCancel }, "Anuluj"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", disabled: !placement, onClick: () => placement && onConfirm(placement) }, "Zatwierd\u017A miejsce"))));
}
